<template>
    <div class="outer-content blur foreground">

        <div class="inner-content">

            <div class="facilitator"></div>

            <DialogueBox :width="752" :height="709" :left="264" :top="71">

                <ValueField v-if="isLivingWithRelatives() == false" class="bank-balance-container"
                    TKey="label_bank_balance" IconClass="icon-bank-balance" Name="Bank Balance"
                    :Value="playerState.bankBalance" :AlwaysShowValue="true"></ValueField>

                <div class="repairs-box-inner">

                    <template v-if="isLivingWithRelatives()">
                        <div class="repairs-title" v-html="T('forced_to_live_with_relatives_title')"></div>
                        <div class="relatives-warning"></div>
                    </template>
                    <template v-else>
                        <div class="repairs-title" v-html="T('repairs_title')"></div>
                        <div class="repairs-warning"></div>
                    </template>

                    <div class="repairs-body">
                        <div v-if="playerState.stopBankDestroyed" v-html="T('stop_bank_destroyed')"></div>
                        <div v-if="playerState.natureBasedSeaDestroyed" v-html="T('nature_based_sea_destroyed')"></div>
                        <div v-if="playerState.seaWallDestroyedHeight == 1" v-html="T('seawall_1_destroyed')"></div>
                        <div v-if="playerState.seaWallDestroyedHeight == 2" v-html="T('seawall_2_destroyed')"></div>
                        <div v-html="repairMessage"></div>
                    </div>

                </div>

                <div class="repairs-costs" v-if="repairCost" v-html="T('repair_costs')"></div>
                <div class="repairs-result" v-if="repairCost">${{ (repairCost * 1000).toLocaleString('us') }}</div>

                <div class="repair-btn-container">
                    <div class="repair-btn-next btn" @click="$emit('next-clicked')" v-html="repairBtnText"></div>
                </div>
            </DialogueBox>

            <!--
            <div class="repair_square">

                <img v-if="isMarae || isFarm || playerState.bankBalance >= repairCost"
                    src="../invision/repairs-warning@3x.svg" class="repair_pic">
                <div v-else class="caravan-base" :class="caravanClass"></div>
-->

        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { riverDamageLevel } from '../../../shared_fca/game';
import { T } from '@/App.vue';
import ValueField from './ValueField.vue';
import playerState, { getRepairCost, isLivingWithRelatives } from '../../../shared_fca/playerstate';
import DialogueBox from './DialogueBox.vue';

export default Vue.extend({
    name: 'RepairPopUp',
    props: {
        riverStage: Number,
        isMarae: Boolean,
        isFarm: Boolean,
        isOverdue: Boolean,
        playerState: Object as PropType<playerState>,
    },
    computed: {

        repairBtnText: {
            cache: false,
            get(): string {
                if (this.repairCost > 0) {
                    return T('make_repairs');
                }
                return T('button_next');
            }
        },

        repairCost: {
            cache: false,
            get(): number {
                return getRepairCost(this.playerState);
            }
        },

        caravanClass: {
            cache: false,
            get(): string {

                /*
                for (const propertyState of this.playerState.properties) {
                    let property = properties[propertyState.property];
                    if (property.caravanClass) {
                        return property.caravanClass;
                    }
                }
                    */

                return "caravan";
            }
        },

        repairMessage: {
            cache: false,
            get(): string {

                if (this.isLivingWithRelatives()) {
                    if (this.playerState.cowshedDestroyed) {
                        //We were forced to move specifically because the cowshed was destroyed
                        return T("farm_forcedmovetocity_modal_cannotrepair_damagedcowshed");
                    }
                    return T("forced_city_move_next_round");
                }
                else if (this.isOverdue) {
                    if (this.repairCost <= this.playerState.bankBalance) {
                        //We can afford to repair this turn
                        if (this.isMarae) {
                            return T("make_repairs_marae_finished");
                        }
                        else {
                            return T("make_repairs_town_finished");
                        }
                    }
                    else {
                        //We can't afford to repair yet
                        if (this.isMarae) {
                            return T("make_repairs_marae_overdue");
                        }
                        else {
                            return T("make_repairs_town_overdue");
                        }
                    }
                }
                else if (this.repairCost == 0) {
                    //We don't need to make any repairs
                    if (this.riverStage == riverDamageLevel.severeFlood) {
                        return T("make_repairs_player_safe_severe_flood");
                    }
                    else if (this.riverStage == riverDamageLevel.highFlood) {
                        return T("make_repairs_player_safe_high_flood");
                    }
                    else {
                        //We have nothing to report
                        return "";
                    }
                }
                else if (this.repairCost <= this.playerState.bankBalance) {
                    //There IS damage to be repaired, but we can repair it
                    if (this.riverStage == riverDamageLevel.highFlood) {
                        return T("make_repairs_high_flood");
                    }
                    else {
                        return T("make_repairs_severe_flood");
                    }
                }
                else {
                    //If we get to here, we can't afford to repair
                    if (this.isMarae) {
                        return T("make_repairs_marae_unable_to_afford");
                    }
                    else if (this.isFarm) {
                        return T("make_repairs_farm_unable_to_afford");
                    }
                    else {
                        return T("make_repairs_town_unable_to_afford");
                    }
                }
            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
        isLivingWithRelatives() {
            return isLivingWithRelatives(this.playerState);
        }
    },
    components: {
        ValueField,
        DialogueBox
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.repair-btn-container {
    position: absolute;
    width: 100%;
    height: 50px;
    bottom: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.repair-btn-next {
    width: 162px;
    height: 50px;
    border-radius: 8px;
    background-color: #B2CD30;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #FFFFFF;
}

.facilitator {
    width: 270px;
    height: 344px;
    top: 379px;
    left: -10px;
    position: absolute;
    background-size: cover;
}

.bank-balance-container {
    position: absolute;
    top: 29px;
    left: 32px;
}

.repairs-box-inner {
    position: absolute;
    top: 51px;
    left: 48px;
    right: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.repairs-title {
    height: 36px;
    margin-bottom: 33px;
    color: #636252;
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.repairs-warning {
    background-image: url("../assets-fca/UI/repairs-warning.svg");
    width: 120px;
    height: 120px;
    background-size: cover;
}

.relatives-warning {
    background-image: url("../assets-fca/UI/relatives-warning.svg");
    width: 120px;
    height: 120px;
    background-size: cover;
}

.repairs-body {
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 36px;
    margin-bottom: 17px;
    padding-left: 48px;
    padding-right: 48px;
}

.repairs-result {
    position: absolute;
    bottom: 182px;
    font-family: Rubik;
    font-size: 24px;
    font-weight: 700;
    line-height: 28.44px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #F2A839;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.repairs-costs {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #636252;
    font-family: Rubik;
    font-weight: 800;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
    text-align: center;
    bottom: 222px;
}

/*
.repair_square {
    width: 800px;
    position: absolute;
    top: 129px;
    left: 159px;
    background-image: url('../invision/speech-bubble-repairs@3x.svg');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.repair_speech {
    height: 509px;
}

.repair_title {
    color: #007D8D;
    font-size: 30px;
    font-weight: 800;
    line-height: 36px;
    margin-top: 81px;
    margin-left: -50px;
}

.repair_pic {
    height: 120px;
    width: 120px;
    margin-top: 22px;
    margin-left: -50px;
}

.repair_body {
    width: 100%;
    color: #333333;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    padding-left: 85px;
    padding-right: 85px;
    margin-top: 22px;
    margin-left: -50px;
}

.repair_result {
    width: 100%;
    color: #B53D30;
    font-family: Rubik;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 33px;
    text-align: center;
    margin-left: -50px;
}

.repair_next_BTN {
    height: 40px;
    width: 110px;
    border-radius: 8px;
    border-style: none;
    background-color: #B2CD30;
    color: #636252;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-top: 17px;
    margin-bottom: 44px;
    margin-left: -50px;
}

.repair_tui {
    height: 948px;
    width: 765px;
    position: absolute;
    top: 200px;
    left: 750px;
}

.repairs-cost-header {
    margin-top: 27px;
    margin-bottom: 0px;
    height: 19px;
    color: #333333;
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    margin-left: -50px;
}

.caravan-base {
    Width: 210.41px;
    Height: 148px;
    margin-top: 36px;
    background-size: 210.41px 148px;
    margin-left: -50px;
}


    */
</style>